import {
  IListColumn,
  IListElement,
} from 'app/services/api5-service/api.interface';

/**
 * Return columns without full empty columns
 *
 * @param columns - BE metadata for columns
 * @param elements - BE data for cells
 */
export function filterEmptyColumns(
  columns: IListColumn[],
  elements: IListElement[],
): IListColumn[] {
  return columns.filter(
    column =>
      column.$type === 'select' ||
      elements.some(element => element[column.$name]),
  );
}
